import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getRemoveDownloadManager from "../../DependencyInjection/removeDownloadManager";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import getChangeDocumentDescription from "../../DependencyInjection/changeDocumentDescription";

const eventDispatcher = getEventDispatcher();

const SaveDownloadFileListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);
    let description = null;

    try {
        description = await eventDispatcher.dispatch('ElectronExtractDocumentDescription', document);
    } catch (error) {
        console.warn(error);
        await eventDispatcher.dispatch('CancelCurrentDownload', document);
        return;
    }

    if (!description) {
        console.warn('Failed to extract description for document ' + document.getId());
        await eventDispatcher.dispatch('CancelCurrentDownload', document);
        return;
    }

    getChangeDocumentDescription().change(document.getIdString(), description);
    await eventDispatcher.dispatch('ChangeDocumentStatusToDownloaded', document);
    getRemoveDownloadManager().remove(document);
}

export default SaveDownloadFileListener;